import { render, staticRenderFns } from "./InvoiceItemsPanel.vue?vue&type=template&id=f89feb42"
import script from "./InvoiceItemsPanel.vue?vue&type=script&lang=js"
export * from "./InvoiceItemsPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports